import React from "react";
import { Select } from "@windmill/react-ui";

const SelectTripType = ({
  register,
  name,
  label,
  readOnly,
  onChange,
  defaultValue,
  required,
}) => {
  return (
    <>
      <Select
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
        name={name}
        {...register(`${name}`, {
          ...(required && { required: `${label} is required!` }),
        })}
        disabled={readOnly}
        value={defaultValue}
        onChange={onChange}
      >
        <option value="" defaultValue hidden>
          Select type
        </option>
        <option value="Airport Pickup">Airport Pickup</option>
        <option value="Airport Drop">Airport Drop</option>
        <option value="Hour Rental">Hour Rental</option>
        <option value="Outstation">Outstation</option>
        <option value="Holiday Package">Holiday Package</option>
        <option value="Oneway">One Way</option>
      </Select>
    </>
  );
};

export default SelectTripType;
